"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabButton = exports.CSS = void 0;
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const icons_1 = require("../icon/icons");
const index_2 = require("../icon/index");
const theme_1 = require("../theme");
exports.CSS = {
    container: 'c-FAB-Button',
    MDL: {
        container: 'mdl-button mdl-button--accent mdl-button--fab'
    }
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        position: 'fixed',
        bottom: '80px',
        right: '8%',
        'z-index': 5
    }
});
exports.FabButton = {
    view(ctx = {}) {
        return (0, mithril_1.m)('button', {
            className: `${exports.CSS.container} ${exports.CSS.MDL.container}`,
            disabled: ctx.disabled,
            title: (0, index_1.Translate)(ctx.title),
            onclick: ctx.onclick
        }, index_2.Icon.view(icons_1.MaterialIcon.ADD));
    }
};
//# sourceMappingURL=fab.button.js.map